export default __webpack_public_path__ + "static/media/logo.e936f202.png";